export enum STALE_TIME {
  MS_100 = 100,
  SECONDS_1 = 1_000,
  SECONDS_5 = 5 * 1_000,
  SECONDS_10 = 10 * 1_000,
  MINUTES_1 = 60_000,
  MINUTES_10 = 10 * 60_000,
  MINUTES_15 = 15 * 60_000,
  HOURS_1 = 60 * 60_000,
}
